// extracted by mini-css-extract-plugin
export default {"main":"Main_main__Bp172","container":"Main_container__uvie0","quote":"Main_quote__AEh0D","imageContainer":"Main_imageContainer__8qLPE"};